module.exports = __webpack_public_path__ + "img/9-2.c689f633.jpg";